// import 'core-js/shim'; // Use from cdn
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import { enableES5 } from 'immer';
import { createBrowserHistory } from 'history';

import React from 'react';
import ReactDOM from 'react-dom';
import 'regenerator-runtime/runtime';

import App from './App';
import { campaign_types } from '@/common/models/campaign-shared';
import './customevent-polyfill';
import mobileSearch from '@/common/components/AddressLookupManyOne/MobileSearchDialog';

enableES5();
const history = createBrowserHistory();

export interface IStofaCartConfig {
    activeTVCampaign: campaign_types;
    activeInternetCampaign: campaign_types;
    cartPath: string;
    broadbandPath: string;
    broadbandPathFibiaCampaign: string;
    broadbandStudieKampagne2021Path: string;
    TVVaelgSelvPath: string;
    TVPackagesPath: string;
}

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        environment: process.env.NODE_ENV,
        beforeBreadcrumb(
            breadcrumb: Sentry.Breadcrumb
        ): Sentry.Breadcrumb | null {
            if (breadcrumb.level === 'log' || breadcrumb.level === 'warning') {
                return null;
            }

            return breadcrumb;
        },
        ignoreErrors: [
            'fbq is not defined',
            'r.trigger is not a function',
            'BKTAG is not defined',
        ],
        allowUrls: [],
        denyUrls: [
            // Drupal
            /sites\/stofa\.dk\//i,
            // Chrome extensions
            /extensions\//i,
            /^chrome:\/\//i,
        ],
        dsn:
            'https://0bc105920c314a8691cf1908bed96b1b@o624537.ingest.sentry.io/5753432',
        integrations: [
            new Integrations.BrowserTracing({
                routingInstrumentation: Sentry.reactRouterV5Instrumentation(
                    history
                ),
            }),
        ],
        tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    });
}

if (!window.jQuery) {
    throw new Error('jQuery is required');
}

console.log('Unified flow: Loaded ...');

let appHasStarted = false;
function runTheApp() {
    if (!appHasStarted) {
        appHasStarted = true;
        window.jQuery(() => {
            console.log('Unified flow: Starting app ...');

            // Hide load placeholder
            window.jQuery('.portal-loading-placeholder--initial').hide();

            window
                .jQuery('#js-header-icon-navigation a[href="/kurv"]')
                .attr('id', 'stofa-flows-global-cart-icon-portal');

            window
                .jQuery('#js-offscreen-navigation-icons a[href="/kurv"]')
                .attr('id', 'stofa-flows-global-cart-icon-portal-mobile');

            // Copy mobile basket to header
            const $mobileCart = window
                .jQuery('#js-offscreen-navigation-icons a[href="/kurv"]')
                .clone();

            window
                .jQuery('#js-nav-trigger')
                .before($mobileCart.addClass('cloned'));

            $mobileCart.before(
                window.jQuery(
                    '<div id="stofa-flows-mobile-raffle-portal"></div>'
                )
            );

            const $root = window.jQuery(
                '<div id="stofa-flows-app-root">SPA root</div>'
            );
            // Todo: $root apparently does not need to be appended to the DOM. React can still run in it as long as it exists free floating. Verify!
            window.jQuery('body').append($root);

            console.log('Unified flow: Rendering ...');
            ReactDOM.render(<App />, $root[0]);
        });
    } else {
        console.log('Unified flow: App was already started');
    }
}

try {
    window.gtag('event', 'optimize.callback', {
        callback: (id: string, name: string) => {
            console.log(`Unified flow: Started with Optimize: ${name}, ${id}`);
            runTheApp();
        },
    });

    window.setTimeout(() => {
        console.log('Unified flow: Started without Optimize');
        runTheApp();
    }, 1000);
} catch (err) {
    console.log('Unified flow: Started without Optimize', err);
    runTheApp();
}
